import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-password-message-dialogue',
  templateUrl: './password-message-dialogue.component.html',
  styleUrl: './password-message-dialogue.component.scss'
})
export class PasswordMessageDialogueComponent {
  title!:any;
message!:any;
passwordError!:any;
  constructor(
    public dialogRef: MatDialogRef<PasswordMessageDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.title = this.data.title;
    this.message = this.data.message;
    this.passwordError =this.data.passwordError;
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}

